// null 체크
export const isEmpty = (value) => {
  return value == null || value === "" || value.length === 0 || value === "undefined" || value === undefined;
};

// params null 처리
export const setParam = (value) => {
  if (value == null || value.length === 0 || value === "undefined") {
    return undefined;
  }
  return value;
};
export const setParam2 = (value) => {
  if (value === null || value === "" || value === "undefined" || value === undefined) {
    return null;
  }
  return value;
};

export const autoTelHyphenConvert = (value) => {
  return value
    .replace(/[^0-9]/g, "")
    .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3")
    .replace("--", "-");
};

export const randomPwGenerator = () => {
  const bigChar = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const smallChar = "abcdefghijklmnopqrstuvwxyz";
  const numChar = "0123456789";
  const spSymbolChar = "!@#$%^&*";

  const bigStrLen = createRandNum(2, 6);
  const smallStrLen = createRandNum(3, 6);
  const numStrLen = createRandNum(2, 6);
  const spSymbolStrLen = createRandNum(1, 6);

  function createRandNum(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function pushChar(strLen, char, array) {
    for (let i = 0; i < strLen; i++) {
      let charIndex = Math.floor(Math.random() * char.length);
      array.push(char.charAt(charIndex));
    }

    return array;
  }

  function shuffle(array) {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
  }

  let charArray = [];

  charArray = pushChar(bigStrLen, bigChar, charArray);
  charArray = pushChar(smallStrLen, smallChar, charArray);
  charArray = pushChar(numStrLen, numChar, charArray);
  charArray = pushChar(spSymbolStrLen, spSymbolChar, charArray);

  charArray = shuffle(charArray);

  return charArray.join("").toString();
};

export const sortData = (a, b) => {
  if (typeof a === "string" && b === "string") {
    return a.localeCompare(b);
  } else if (typeof a === "number" && typeof b === "number") {
    return a === b ? 0 : a > b ? 1 : -1;
  } else {
    const convertA = a === null || a === "undefined" || a === undefined ? "" : a.toString();
    const convertB = b === null || b === "undefined" || b === undefined ? "" : b.toString();
    return convertA.localeCompare(convertB);
  }
};

// session parameter 등록
export const setSessionParam = (model) => {
  sessionStorage.setItem(window.location.pathname, JSON.stringify(model));
};
// session parameter 조회
export const getSessionParam = (value) => {
  try {
    return JSON.parse(sessionStorage.getItem(window.location.pathname))[value];
  } catch (error) {
    return "";
  }
};

// set session json format parameter
export const setGlobalSessionParam = (model) => {
  // try {
  //     for(let key in model) {
  //         if (model.hasOwnProperty(key)) {
  //             sessionStorage.setItem(key, model[key]);
  //         }
  //     }
  // } catch (e) {}

  let globalParam = null;

  try {
    globalParam = JSON.parse(sessionStorage.getItem("global"));
  } catch (error) {}

  if (globalParam !== null) {
    for (let key in model) {
      if (model.hasOwnProperty(key)) {
        globalParam = { ...globalParam, [key]: model[key] };
      }
    }
  } else {
    globalParam = model;
  }

  sessionStorage.setItem("global", JSON.stringify(globalParam));
};
export const getGlobalSessionParam = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem("global"))[key];
  } catch (error) {
    return "";
  }
};
